import { IStorageBase } from '../../base';

export interface ILocalStorage extends IStorageBase {}
